module.exports = __webpack_public_path__ + "img/square-small.e81ec1e3.svg";